import { ImageVideoPreview } from "../../../common/ImageVideoPreview";
import { getRowKey } from "../../../../helpers";
import { mapRelativeToPixels } from "../../../../helpers/itemsHelper";
import { ITEM_TYPES, Logo as StoreLogo } from "../../../../types";

export const Logo = ({
  logo,
  previewWidth,
  previewHeight,
  placeholderAssets,
}: {
  logo: StoreLogo;
  previewWidth: number;
  previewHeight: number;
  placeholderAssets?: Record<string, string>;
}) => {
  const assetId = getRowKey(logo);
  const path = logo.path;

  return (
    <ImageVideoPreview
      type={ITEM_TYPES.Image}
      assetId={assetId}
      path={path}
      placeholderAssets={placeholderAssets}
      style={{
        objectFit: "contain",
        width: mapRelativeToPixels(logo.size.width, previewWidth),
        height: mapRelativeToPixels(logo.size.height, previewHeight),
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img#styling_with_css
        display: "block",
      }}
    />
  );
};
